import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { _className, LL_V_L, Button, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
import './Component_EpidemiologyEditor.scss';
import { QScrollWrapper } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
import { Component_EpidemiologyItemEditor } from './Component_EpidemiologyItemEditor.js';
import { cloneObj } from '@nu-art/ts-common';
import { initialEpidemiology } from '@app/dp-shared';
const ViewMode_View = 'view';
const ViewMode_Edit = 'edit';
export class Component_EpidemiologyEditor extends TS_EditableItemComponentProto {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    addEpidemiology = async () => {
        const dp = this.state.editable;
        const epidemiology = dp.editProp('epidemiology', []);
        await epidemiology.updateArrayAt(cloneObj(initialEpidemiology));
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'epidemiology-editor', children: [this.renderEpidemiology(), this.renderEpidemiologyNotes()] });
    }
    renderEpidemiology = () => {
        const epidemiology = this.state.editable.editProp('epidemiology', []);
        const editMode = this.state.editMode;
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Epidemiology', children: [editMode && _jsxs(Button, { variant: 'primary', onClick: this.addEpidemiology, children: [_jsx(ICONS.advisor_v5_plus.component, {}), " Add Epidemiology"] }), _jsx(QScrollWrapper, { children: epidemiology.item.map((_item, index) => {
                        const item = epidemiology.editProp(index, {});
                        const className = _className('epidemiology-card', editMode && 'edit-mode');
                        return _jsxs("div", { className: className, children: [editMode && _jsx(ICONS.bin.component, { className: 'epidemiology-card__delete', onClick: async () => {
                                        await epidemiology.removeArrayItem(index);
                                    } }), _jsx(Component_EpidemiologyItemEditor, { editable: item, editMode: this.state.editMode }, index)] });
                    }) })] });
    };
    renderEpidemiologyNotes = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Epidemiology Notes', error: editable.hasError('epidemiologyNotes'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("p", { children: editable.item.epidemiologyNotes })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsx(DefaultEditor_TextArea, { editable: editable, prop: 'epidemiologyNotes' })
                    }
                ] }) });
    };
}
//# sourceMappingURL=Component_EpidemiologyEditor.js.map